export default "/images/f0bf29d23b2e093252e83a441d373136.avif";